import { defineMessages, FormattedMessage } from 'react-intl';

export const intlPrefix = 'registerWatchModal';

export const messages = defineMessages({
  referenceHint: {
    id: `${intlPrefix}.referenceHint`,
    defaultMessage: 'Where to find model reference and serial number?',
  },
  scanQrCode: {
    id: `${intlPrefix}.scanQrCode`,
    defaultMessage: 'Please scan the QR code on warranty card',
  },
});

export const ScanQrCodeWarrantyWatch = (
  <FormattedMessage
    defaultMessage='Scan QR code on warranty card'
    id={`${intlPrefix}.scanQrCodeWarrantyWatch`}
  />
);

export const EnterSerialNumber = (
  <FormattedMessage
    defaultMessage='Enter my serial number'
    id={`${intlPrefix}.enterSerialNumber`}
  />
);
